var map = {
	"./air-conditioner.svg": 1562,
	"./airplane.svg": 1563,
	"./airport.svg": 1564,
	"./approved.svg": 1565,
	"./aquapark.svg": 1566,
	"./arrow-answer-bubble.svg": 1567,
	"./arrow-back.svg": 1568,
	"./arrow-flight.svg": 1569,
	"./arrow-right-top.svg": 1570,
	"./arrow-right.svg": 1571,
	"./bar.svg": 1572,
	"./beach-surface-pebble.svg": 1573,
	"./beach-surface-platform.svg": 1574,
	"./beach-surface-sand-pebble.svg": 1575,
	"./beach-surface-sand.svg": 1576,
	"./beachsurface.svg": 1577,
	"./card.svg": 1578,
	"./check.svg": 1579,
	"./clock.svg": 1580,
	"./cvv.svg": 1581,
	"./double-arrow.svg": 1582,
	"./empty-hotel-map.svg": 1583,
	"./filters/clear-filters.svg": 1584,
	"./filters/filter-button.svg": 1585,
	"./filters/instant-confirm-colored.svg": 1586,
	"./filters/instant-confirm.svg": 1587,
	"./filters/search-distance.svg": 1588,
	"./filters/search-lift.svg": 1589,
	"./fire.svg": 1590,
	"./flight-direct-mobile.svg": 1591,
	"./flight-direct.svg": 1592,
	"./flight-direct__additional-mobile.svg": 1593,
	"./flight-direct__additional.svg": 1594,
	"./flight-transition-mobile.svg": 1595,
	"./flight-transition.svg": 1596,
	"./flight-transition__additional-mobile.svg": 1597,
	"./flight-transition__additional.svg": 1598,
	"./food.svg": 1599,
	"./free-cancellation-colored.svg": 1600,
	"./fuel-green.svg": 1601,
	"./fuel-white.svg": 1602,
	"./funicular.svg": 1603,
	"./gallery-empty.svg": 1604,
	"./garranty.svg": 1605,
	"./gender-female.svg": 1606,
	"./gender-male.svg": 1607,
	"./gender-unidentified.svg": 1608,
	"./gift.svg": 1609,
	"./glass.svg": 1610,
	"./gym.svg": 1611,
	"./hand-luggage.svg": 1612,
	"./heated-pool.svg": 1613,
	"./hold-luggage.svg": 1614,
	"./hotel-reply.svg": 1615,
	"./included-services.svg": 1616,
	"./included.svg": 1617,
	"./kids-club.svg": 1618,
	"./kids-menu.svg": 1619,
	"./kids-pool.svg": 1620,
	"./lightning.svg": 1621,
	"./lock.svg": 1622,
	"./logo.svg": 1623,
	"./lt-extra/bonus_insurance.svg": 1624,
	"./lt-extra/bonus_ivi.svg": 1625,
	"./luggage-wrapping.svg": 1626,
	"./man.svg": 1627,
	"./map-button.svg": 1628,
	"./map/collapse-arrows.svg": 1629,
	"./map/expand-arrows.svg": 1630,
	"./massage.svg": 1631,
	"./nanny.svg": 1632,
	"./only-lt-half.svg": 1633,
	"./parking.svg": 1634,
	"./payment-mir.svg": 1635,
	"./paymenttype.svg": 1636,
	"./plane-arrival.svg": 1637,
	"./plane.svg": 1638,
	"./private-beach.svg": 1639,
	"./rest_types/active.svg": 1640,
	"./rest_types/couples.svg": 1641,
	"./rest_types/family.svg": 1642,
	"./review-tab-selected.svg": 1643,
	"./sauna.svg": 1644,
	"./search-sorting.svg": 1645,
	"./searcher-empty-request.svg": 1646,
	"./searcher-filtered-empty.svg": 1647,
	"./sidebar-bottom-triangle.svg": 1648,
	"./sidebar-menu-active.svg": 1649,
	"./sign_additional.svg": 1650,
	"./ski-in-ski-out.svg": 1651,
	"./social-fb.svg": 1652,
	"./social-share.svg": 1653,
	"./social-vk.svg": 1654,
	"./special.svg": 1655,
	"./success_additional.svg": 1656,
	"./swimming-pool.svg": 1657,
	"./thumbs-up.svg": 1658,
	"./wave.svg": 1659,
	"./wifi.svg": 1660
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 978;